var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33301 28C8.59967 28 7.97212 27.7391 7.45034 27.2173C6.92856 26.6956 6.66723 26.0676 6.66634 25.3333V8H5.33301V5.33333H11.9997V4H19.9997V5.33333H26.6663V8H25.333V25.3333C25.333 26.0667 25.0721 26.6947 24.5503 27.2173C24.0286 27.74 23.4006 28.0009 22.6663 28H9.33301ZM11.9997 22.6667H14.6663V10.6667H11.9997V22.6667ZM17.333 22.6667H19.9997V10.6667H17.333V22.6667Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon-delete.84757c36cb9fb0c71dba7614e6b17fee.svg";
export { ForwardRef as ReactComponent };